module.exports = __webpack_public_path__ + "img/member-first-circle.f437e5e8.svg";